import { axiosAdmin } from "config/axios.config";

const API_VERSION_URL = "/doc/api-version";

const apiVersionSvc = {
  getAll: async () => {
    const response = await axiosAdmin.get(`${API_VERSION_URL}`);
    return response;
  },
};

export default apiVersionSvc;
